import { useTranslation } from "react-i18next";
import { setLang, type Lang } from "../i18n";

/** Convenience wrapper around react-i18next with RTL + name-picking helpers. */
export function useLang() {
  const { t, i18n } = useTranslation();
  const lang: Lang = i18n.language === "ar" ? "ar" : "en";
  const dir: "rtl" | "ltr" = lang === "ar" ? "rtl" : "ltr";

  const toggle = () => setLang(lang === "ar" ? "en" : "ar");

  /** Pick the English or Arabic variant of a value. */
  const pick = (en: string, ar: string) => (lang === "ar" ? ar : en);

  return { t, lang, dir, toggle, pick };
}
